import { useState } from 'react';
import { useService } from 'hooks/useService';
import { UpdatePhone } from 'components/Login/_components/MFAVerification/UpdatePhone';
import { VerifyCode } from 'components/Login/_components/MFAVerification/VerifyCode';
import { ChooseType } from 'components/Login/_components/MFAVerification/ChooseType';
import { general_error_toastr } from 'components/partials/Notification';
import { useLoginContext } from '../../_context/useLoginContext';
import { SmsOptInModal } from 'components/UserAccount/SmsOptInModal';

export const MFAVerification = () => {
    const { phone: _phone, requirePhone } = useLoginContext();
    const [disabledType, setDisabledType] = useState(false);
    const [phone, setPhone] = useState('');
    const [showInput, setShowInput] = useState(false);
    const [showSmsOptInModal, setShowSmsOptInModal] = useState(false);
    const [_, fireMFA] = useService({ url: '/users/account/mfa/request-otp' });

    const handleSubmitType = type => {
        setDisabledType(true);
        fireMFA({ params: { method: type } })
            .then((response) => {
                if (!response?.requested && response?.reason) {
                    setShowSmsOptInModal(true);
                } else {
                    setShowInput(true);
                }
            })
            .catch(() => general_error_toastr());
    };

    const handleCloseSmsModal = () => {
        setShowSmsOptInModal(false);
        setDisabledType(false);
    };

    if (requirePhone) {
        return <UpdatePhone setPhone={setPhone} phone={phone}/>;
    }

    const requestNewCode = (set) => {
        setDisabledType(false);
        setShowInput(set);
    };

    return (
        <>
            {
                requirePhone ? (
                    <UpdatePhone setPhone={setPhone} phone={phone}/>
                ) : (
                    <>
                        <div className="row marginB20">
                            <div className="col text-center">
                                <h2 className="section-title">Identity Verification</h2>
                            </div>
                            <br/>
                        </div>
                        {showInput
                            ? <VerifyCode {...{ requestNewCode, phone: phone.phone || _phone }} />
                            : <ChooseType
                                disabled={disabledType}
                                onSubmit={handleSubmitType}
                                phone={phone.phone || _phone}
                            />
                        }
                        <SmsOptInModal 
                            show={showSmsOptInModal} 
                            onClose={handleCloseSmsModal}
                            mode="mfaOptOut"
                        />
                    </>
                )
            }
        </>
    );
};
